export const isAuthenticated = (state) => (state.auth.isLogin ? true : false);
